<script lang="ts" setup>
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import useDashboardContext from '@Use/useDashboardContext';
import { DetailsLayout, FlowLayout, IllustrationVerifiedId } from '@Shared';
import VerificationSubmittedContent from '@Components/match/VerificationSubmittedContent.vue';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const { isDashboardContext, isLoadingContext } = useDashboardContext();
</script>

<template>
    <app-page-loader v-if="isLoadingContext" />

    <details-layout
        v-else-if="isDashboardContext"
        title="Your verification was successful"
        illustration-align="center"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <template #illustration>
            <illustration-verified-id />
        </template>

        <verification-submitted-content
            :show-title="false"
            :show-illustration="false"
            :show-close-notice="false" />
    </details-layout>

    <flow-layout
        v-else
        is-white-label
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :show-back-button="false">

        <verification-submitted-content />
    </flow-layout>
</template>
